import React, { useMemo, useCallback } from "react";
import { Icon } from "semantic-ui-react";

import moment from "moment";
import { useIntl } from "react-intl";

// Common
import DateTextBox from "react-lib/apps/common/DateTextBox";

// UX
import DPOHistoryReviewTpUX from "./DPOHistoryReviewTPUX";
import ModalItemFilterCustom from "./ModalItemFilterCustom";
import PopupBottomLeft from "./common/PopupBottomLeft";

// Utils
import * as utils from "react-lib/utils";
import { getLocationsSet, tidyLocation2 } from "react-lib/apps/common/CUDENT/DentalRecordUtil";
import SubTreatmentRecord from "./SubTreatmentRecord";

// Types
export type ReviewTpProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => void) => any;

  // data
  columnsHistoryTp?: any[];
  historyReviewTpData: any;
  patientId: any;
  tableHeight?: string;
  languageUX: string;
  historyDate: any;
  organItems?: any[];
  hideTreatmentForm?: boolean;
  selectedHistoryTp?: any;
  // filter
  doctorFilterListTp?: any[];
  clinicFilterListTp?: any[];
  locationFilterListTp?: any[];
  treatmentFilterListTp?: any[];
  treatmentCodeFilterListTp?: any[];
  statusFilterList?: any[];
  openModalDoctorTpFilter?: boolean;
  openModalFilterClinicTp?: boolean;
  openModalFilterLocationTp?: boolean;
  openModalFilterTreatmentTp?: boolean;
  openModalFilterTreatmentCodeTp?: boolean;
  openModalFilterStatus?: boolean;

  anestheticOptions?: any[];

  // callback
  handleGetHistoryTp: () => any;
  handleOnFocusFindingsRowTp: (state: any, rowInfo: any) => any;
  onChangeDate?: (key: "start" | "end") => (date: string) => any;
  handleCloseTreatmentRecord: () => any;
};

const ReviewTp = (props: ReviewTpProps) => {
  const intl = useIntl();

  // Callback
  const checkHistoryFilterActive = useCallback((list: any[] = []) => {
    return list.find((item: any) => item.is_selected === false);
  }, []);

  const renderLocationCell = useCallback(
    (row: any) => {
      const original = row.original || {};
      const locationsSet = getLocationsSet(`${original.examination_location}`, props.organItems || []);

      const location = tidyLocation2(locationsSet, props.organItems || []);

      return (
        <div style={{ display: "flex", alignItems: "flex-start", maxWidth: "100%", justifyContent: "center" }}>
          <div
            style={{
              color: original.status === "C" ? "#44A110" : "black",
              wordBreak: "break-word",
              marginRight: "3px",
            }}
          >
            {location.toString()}
          </div>
          {original.description && (
            <PopupBottomLeft
              content={original.description}
              trigger={<Icon className="ignore-prevent" name="info circle" color="blue" style={{ fontSize: "1.4rem" }} />}
              hideOnScroll={false}
            />
          )}
        </div>
      );
    },
    [props.organItems]
  );

  const renderTreatmentCell = useCallback(
    (row: any) => {
      if (!["", undefined].includes(row?.original?.treatment_issue?.treatment_record)) {
        return (
          <div style={{ textAlign: "center" }}>
            {!props.hideTreatmentForm && props.selectedHistoryTp.id === row.original.id ? (
              <Icon name="folder open outline" color="blue" size="big" />
            ) : (
              <img
                src="/static/images/haveRecord.png"
                style={{ width: "25px" }}
                onClick={() => {
                  props.onEvent({
                    message: "handleSetSelectedTreatmentRecord",
                    params: { row: row.original },
                  });
                }}
              />
            )}
          </div>
          //  <div style={{ textAlign: "center" }}>
          //    {
          //      <Icon
          //        name={props.selectedHistoryTp?.id === row.original.id ? "folder open outline" : "folder outline"}
          //        color={props.selectedHistoryTp?.id === row.original.id ? "green" : "grey"}
          //        onClick={(e: any) => {
          //          props.onEvent({ message: "handleSetSelectedTreatmentRecord", params: { row: row.original } });
          //        }}
          //        style={{ cursor: "pointer" }}
          //      />
          //    }
          //  </div>
        );
      } else {
        return;
      }
    },
    [props.selectedHistoryTp]
  );

  // Memo
  const columnsHistoryTp = useMemo(() => {
    const columns = [
      {
        Header: "Created Date",
        resizeable: false,
        accessor: "started",
        // show: !props.readOnly,
        Cell: ({ original }: any = {}) => (
          <div style={{ textAlign: "center" }}>
            {original?.created}
            <br />
            {original?.created_user_full_name}
          </div>
        ),
      },
      {
        Header: (
          <div style={{ display: "flex", alignItems: "center" }}>
            {intl.formatMessage({ id: "cukey65" })}
            <Icon
              className="review-tp-filter-doctor"
              name="filter"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                zIndex: 2,
                color: checkHistoryFilterActive(props.doctorFilterListTp) ? "yellow" : "",
              }}
              onClick={() => props.setProp("openModalDoctorTpFilter", !props.openModalDoctorTpFilter)}
            />
          </div>
        ),
        accessor: "treatment_issue.edit_user_full_name",
        resizeable: false,
        // Cell: (row) => <div style={{ textAlign: "center" }}>{row.original.items[0].doctor_fullname}</div>,
      },
      {
        Header: (
          <div style={{ display: "flex", alignItems: "center" }}>
            {intl.formatMessage({ id: "cukey54" })}
            <Icon
              className="review-tp-filter-clinic"
              name="filter"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                zIndex: 2,
                color: checkHistoryFilterActive(props.clinicFilterListTp) ? "yellow" : "",
              }}
              onClick={() => props.setProp("openModalFilterClinicTp", !props.openModalFilterClinicTp)}
            />
          </div>
        ),
        accessor: "division.name",
        resizeable: false,
      },
      {
        Header: (
          <div style={{ display: "flex", alignItems: "center" }}>
            {intl.formatMessage({ id: "cukey112" })}
            <Icon
              className="review-tp-filter-location"
              name="filter"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                zIndex: 2,
                color: checkHistoryFilterActive(props.locationFilterListTp) ? "yellow" : "",
              }}
              onClick={() => props.setProp("openModalFilterLocationTp", !props.openModalFilterLocationTp)}
            />
          </div>
        ),
        accessor: "examination_location",
        resizeable: false,
        Cell: renderLocationCell,
      },
      {
        Header: (
          <div style={{ display: "flex", alignItems: "center" }}>
            {intl.formatMessage({ id: "cukey209" })}
            <Icon
              className="review-tp-filter-treatment"
              name="filter"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                zIndex: 2,
                color: checkHistoryFilterActive(props.treatmentFilterListTp) ? "yellow" : "",
              }}
              onClick={() => props.setProp("openModalFilterTreatmentTp", !props.openModalFilterTreatmentTp)}
            />
          </div>
        ),
        accessor: "treatment.name",
        minWidth: 90,
        Cell: ({ original }: any = {}) => <div style={{ color: original?.status === "C" ? "#44A110" : "black" }}>{original?.treatment?.name}</div>,
      },
      {
        Header: (
          <div style={{ display: "flex", alignItems: "center" }}>
            {intl.formatMessage({ id: "cukey214" })}
            <Icon
              className="review-tp-filter-code"
              name="filter"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                zIndex: 2,
                color: checkHistoryFilterActive(props.treatmentCodeFilterListTp) ? "yellow" : "",
              }}
              onClick={() => props.setProp("openModalFilterTreatmentCodeTp", !props.openModalFilterTreatmentCodeTp)}
            />
          </div>
        ),
        accessor: "treatment_issue_list",
        resizeable: false,
        Cell: ({ original }: any = {}) => {
          // console.log('treatment_issue_list original: ', original);

          // return <>
          // {original?.treatment_issue_list?.map((i :any, idx: number) => {
          //   let newLine = idx !== 0 ? <br/> : null
          //   return <> {newLine} <div style={{ color: original?.status === "C" ? "#44A110" : "black" }}>{i?.product_name}</div> </>
          // })}
          // </>

          return original?.treatment_issue_list
            ?.filter((i: any) => i?.product)
            ?.filter((i: any) => i.active)
            ?.map((i: any, idx: number) => (
              <>
                {" "}
                {idx !== 0 ? "\n\n" : null} <span style={{ color: original?.status === "C" ? "#44A110" : "black" }}>{`[${i?.product_code}] ${i?.product_name}`}</span>
              </>
            ));
        },
      },
      {
        Header: (
          <div style={{ display: "flex", alignItems: "center" }}>
            {intl.formatMessage({ id: "cukey197" })}
            <Icon
              className="review-tp-filter-status"
              name="filter"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                zIndex: 2,
                color: checkHistoryFilterActive(props.statusFilterList) ? "yellow" : "",
              }}
              onClick={() => props.setProp("openModalFilterStatus", !props.openModalFilterStatus)}
            />
          </div>
        ),
        accessor: "status_label",
        resizeable: false,
        Cell: ({ original }: any = {}) => (
          <>
            <div style={{ color: original?.status === "C" ? "#44A110" : original?.status === "X" ? "red" : "black" }}>{original?.status_label}</div>
            {original?.status === "C" ? (
              <>{original?.edited_th}</>
            ) : original?.status === "X" ? (
              <>
                {original?.canceled_reason_name}
                <br />
                <font style={{ fontWeight: "bold" }}>โดย</font> {original?.canceled_user_full_name}
                <br /> {original?.edited_th}
              </>
            ) : (
              <></>
            )}
          </>
        ),
        // Cell: (row) => <div style={{ textAlign: "center" }}>{row.original.items[0].doctor_fullname}</div>,
      },
      {
        Header: "Level",
        accessor: "urgency_label",
        resizeable: false,
      },
      {
        Header: "Treatment record",
        accessor: "diagram",
        resizeable: false,
        Cell: renderTreatmentCell,
      },
      ...(props.columnsHistoryTp || []),
    ];

    return Array.from(new Map(columns.map((item) => [item.Header, item])).values());
  }, [
    props.columnsHistoryTp,
    props.doctorFilterListTp,
    props.clinicFilterListTp,
    props.openModalDoctorTpFilter,
    props.openModalFilterClinicTp,
    props.locationFilterListTp,
    props.openModalFilterLocationTp,
    props.treatmentFilterListTp,
    props.openModalFilterTreatmentTp,
    props.treatmentCodeFilterListTp,
    props.openModalFilterTreatmentCodeTp,
    props.statusFilterList,
    props.openModalFilterStatus,
    renderLocationCell,
    renderTreatmentCell,
  ]);

  console.log("----- l ", props.historyReviewTpData);

  return (
    <DPOHistoryReviewTpUX
      handleOnFocusFindingsRowTp={props.handleOnFocusFindingsRowTp}
      columnsHistoryTp={columnsHistoryTp}
      historyReviewTpData={props.historyReviewTpData}
      handleGetHistoryTp={props.handleGetHistoryTp}
      cardFilterClinicTpElement={
        props.openModalFilterClinicTp ? (
          <ModalItemFilterCustom
            name="Clinic"
            style={{ margin: "0.35rem 0 0 -7rem" }}
            data={props.clinicFilterListTp}
            onClose={() => props.setProp("openModalFilterClinicTp", false)}
            textField="name"
            target="review-tp-filter-clinic"
            classNameZoom={["#main-ptm #detail", "#main-dpo .history-tab"]}
            onSelect={(list, listArray) =>
              props.onEvent({
                message: "SetClinicFilterTp",
                params: {
                  filter: list,
                },
              })
            }
            setProp={props.setProp}
          />
        ) : null
      }
      cardFilterDentistTpElement={
        props.openModalDoctorTpFilter ? (
          <ModalItemFilterCustom
            name="Dentist"
            style={{ margin: "0.35rem 0 0 -7rem" }}
            data={props.doctorFilterListTp}
            onClose={() => props.setProp("openModalDoctorTpFilter", false)}
            textField="name"
            target="review-tp-filter-doctor"
            classNameZoom={["#main-ptm #detail", "#main-dpo .history-tab"]}
            onSelect={(list) =>
              props.onEvent({
                message: "SetDoctorFilterTp",
                params: {
                  filter: list,
                },
              })
            }
            setProp={props.setProp}
          />
        ) : null
      }
      cardFilterLocationTpElement={
        props.openModalFilterLocationTp ? (
          <ModalItemFilterCustom
            name="Location"
            style={{ margin: "0.35rem 0 0 -3rem" }}
            data={props.locationFilterListTp}
            onClose={() => props.setProp("openModalFilterLocationTp", false)}
            textField="name"
            target="review-tp-filter-location"
            classNameZoom={["#main-ptm #detail", "#main-dpo .history-tab"]}
            onSelect={(list, listArray) =>
              props.onEvent({
                message: "SetLocationFilterTp",
                params: {
                  filter: list,
                },
              })
            }
            setProp={props.setProp}
          />
        ) : null
      }
      cardFilterStatusTpElement={
        props.openModalFilterStatus ? (
          <ModalItemFilterCustom
            name="Status"
            style={{ margin: "0.35rem 0 0 13rem" }}
            data={props.statusFilterList}
            onClose={() => props.setProp("openModalFilterStatus", false)}
            textField="name"
            target="review-tp-filter-status"
            classNameZoom={["#main-ptm #detail", "#main-dpo .history-tab"]}
            onSelect={(list) =>
              props.onEvent({
                message: "SetStatusFilter",
                params: {
                  filter: list,
                },
              })
            }
            setProp={props.setProp}
          />
        ) : null
      }
      cardFilterTreatmentCodeTpElement={
        props.openModalFilterTreatmentCodeTp ? (
          <ModalItemFilterCustom
            name="Treatment code"
            style={{ margin: "0.35rem 0 0 7rem" }}
            data={props.treatmentCodeFilterListTp}
            onClose={() => props.setProp("openModalFilterTreatmentCodeTp", false)}
            textField="name"
            target="review-tp-filter-code"
            classNameZoom={["#main-ptm #detail", "#main-dpo .history-tab"]}
            onSelect={(list, listArray) =>
              props.onEvent({
                message: "SetTreatmentCodeFilterTp",
                params: {
                  filter: listArray,
                },
              })
            }
            setProp={props.setProp}
          />
        ) : null
      }
      cardFilterTreatmentTpElement={
        props.openModalFilterTreatmentTp ? (
          <ModalItemFilterCustom
            name="Treatment"
            style={{ margin: "0.35rem 0 0 3rem" }}
            data={props.treatmentFilterListTp}
            onClose={() => props.setProp("openModalFilterTreatmentTp", false)}
            textField="name"
            target="review-tp-filter-treatment"
            classNameZoom={["#main-ptm #detail", "#main-dpo .history-tab"]}
            onSelect={(list, listArray) =>
              props.onEvent({
                message: "SetTreatmentFilterTp",
                params: {
                  filter: list,
                },
              })
            }
            setProp={props.setProp}
          />
        ) : null
      }
      hideTreatmentForm={props.hideTreatmentForm}
      patientId={props.patientId}
      tableHeight={props.tableHeight}
      languageUX={props.languageUX}
      // iconClose={<Icon name="close" size="large" style={{ cursor: "pointer" }} color="grey" onClick={props.handleCloseTreatmentRecord} />}
      tpStartDate={
        <div style={{ paddingTop: "5px" }}>
          <DateTextBox
            name="tpStartDate"
            maxDate={utils.adToBe(moment())}
            value={props.historyDate.tpStartDate}
            // onChange={(date) => {
            //   props.setProp("historyDate.tpStartDate", date);
            // }}
            onChange={props.onChangeDate?.("start")}
          />
        </div>
      }
      tpEndDate={
        <div style={{ paddingTop: "5px" }}>
          <DateTextBox
            name="tpEndDate"
            maxDate={utils.adToBe(moment())}
            value={props.historyDate.tpEndDate}
            // onChange={(date) => {
            //   props.setProp("historyDate.tpEndDate", date);
            // }}
            onChange={props.onChangeDate?.("end")}
          />
        </div>
      }
      treatmentRecord={
        !props.hideTreatmentForm ? (
          <SubTreatmentRecord
            readonly={true}
            handleCloseTreatmentRecord={props.handleCloseTreatmentRecord}
            selectedTreatmentPerform={props.selectedHistoryTp?.treatment_issue}
            anestheticOptions={props.anestheticOptions}
          />
        ) : null
      }
    />
  );
};

ReviewTp.displayName = "ReviewTp";

export default React.memo(ReviewTp);
